var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getGroup, getGroupInEvent, postGroupInEvent } from "../../../../../data/api";
import { Alert, DotsLoader, Form, Loader } from "@brushfire/ui";
import WidgetFieldset from "../../../../Helpers/WidgetFieldset";
import FormikContextListener from "../../../../Helpers/FormikContextListener";
import Constants from "../../../../../data/constants";
import { handleErrors } from "../../../../../data/helpers";
import { useDispatch, useSelector } from "react-redux";
import AttendeeTypes from "../AttendeeTypes";
import { setLocal, LOCAL_STORAGE_KEYS } from "../../../../../data/localStorageHelpers";
import { clearInlineErrors, setInlineError } from "../../../../../store/AppState/actions";
import InlineError from "../../../../UI/InlineError";
var useTypedSelector = useSelector;
var AutoGroup = function (_a) {
    var _b, _c, _d;
    var eventData = _a.eventData, path = _a.path, typeCode = _a.typeCode;
    var history = useHistory();
    var location = useLocation();
    var dispatch = useDispatch();
    var queryParams = new URLSearchParams(location.search.toLowerCase());
    var paramsGroup = (_b = queryParams.get("group")) !== null && _b !== void 0 ? _b : "";
    var paramsAutoCreate = (_c = queryParams.get("autocreate")) !== null && _c !== void 0 ? _c : "";
    var paramsContinueToRegister = (_d = queryParams.get("continuetoregister")) !== null && _d !== void 0 ? _d : "";
    var attendeeTypeData = useTypedSelector(function (store) { return store.attendees; }).attendeeTypeData;
    var _e = __read(useState(), 2), preSelectedAttendeeTypeId = _e[0], setPreSelectedAttendeeTypeId = _e[1];
    var _f = __read(useState(false), 2), isLoaded = _f[0], setIsLoaded = _f[1];
    var _g = __read(useState(), 2), groupCreatedName = _g[0], setGroupCreatedName = _g[1];
    var _h = __read(useState(), 2), existingGroupName = _h[0], setExistingGroupName = _h[1];
    var _j = __read(useState(), 2), oldGroupName = _j[0], setOldGroupName = _j[1];
    if (paramsGroup.trim().toLowerCase() === "none") {
        paramsGroup = "00000000-0000-0000-0000-000000000000";
    }
    useEffect(function () {
        if (paramsGroup && attendeeTypeData && !groupCreatedName) {
            getGroupInEvent(paramsGroup, eventData.eventNumber.toString())
                .then(function (_a) {
                var data = _a.data;
                setExistingGroupName(data.name);
                setIsLoaded(true);
            })
                .catch(function (err) {
                var _a, _b;
                if (err.response.status === 404) {
                    getGroup(paramsGroup)
                        .then(function (_a) {
                        var oldGroup = _a.data;
                        setOldGroupName(oldGroup.name);
                        var newType = attendeeTypeData.find(function (a) { return a.name === oldGroup.typeName; });
                        setPreSelectedAttendeeTypeId(newType === null || newType === void 0 ? void 0 : newType.id);
                        if (paramsAutoCreate === "true" && newType) {
                            postGroupInEvent(oldGroup.id, eventData.eventNumber.toString(), {
                                attendeeTypeId: newType.id,
                            })
                                .then(function (_a) {
                                var _b;
                                var newGroup = _a.data;
                                setLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : ""), JSON.stringify({
                                    groupId: newGroup.id,
                                    name: newGroup.name,
                                }), 60 * 30);
                                setGroupCreatedName(newGroup.name);
                            })
                                .catch(function (err) {
                                var _a, _b;
                                if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                                    dispatch(setInlineError({ autoGroupErrors: err.response.data.message }));
                                }
                                else {
                                    handleErrors(err, dispatch);
                                }
                            })
                                .finally(function () {
                                setIsLoaded(true);
                            });
                        }
                        else {
                            setIsLoaded(true);
                        }
                    })
                        .catch(function (err) {
                        var _a, _b;
                        if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                            dispatch(setInlineError({ autoGroupErrors: err.response.data.message }));
                        }
                        else {
                            handleErrors(err, dispatch);
                        }
                        setIsLoaded(true);
                    });
                }
                else {
                    if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                        dispatch(setInlineError({ autoGroupErrors: err.response.data.message }));
                    }
                    else {
                        handleErrors(err, dispatch);
                    }
                }
            });
        }
    }, [paramsGroup, attendeeTypeData]);
    var onSubmit = function (values, formikHelpers, setGlobalError, attendeeTypeId) {
        dispatch(clearInlineErrors());
        postGroupInEvent(paramsGroup, eventData.eventNumber.toString(), {
            attendeeTypeId: attendeeTypeId,
        })
            .then(function (_a) {
            var _b;
            var newGroup = _a.data;
            setLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : ""), JSON.stringify({
                groupId: newGroup.id,
                name: newGroup.name,
            }), 60 * 30);
            setGroupCreatedName(newGroup.name);
        })
            .catch(function (err) {
            var _a, _b;
            if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                dispatch(setInlineError({ autoGroupErrors: err.response.data.message }));
            }
            else {
                handleErrors(err, dispatch);
            }
        })
            .finally(function () {
            setIsLoaded(true);
            formikHelpers.setSubmitting(false);
        });
    };
    var onContinue = function (values, formikHelpers) {
        formikHelpers.setSubmitting(false);
        history.push(Constants.Routes.eventStart
            .replace(":clientKey", eventData.clientKey)
            .replace(":urlKey", eventData.urlKey)
            .replace(":eventNumber", eventData.eventNumber.toString()));
    };
    if (!isLoaded || !attendeeTypeData) {
        return (_jsx(Loader, { customLoadingIcon: _jsx(DotsLoader, { containerClasses: "global-loader-container" }), classes: "global-loader" }));
    }
    if (existingGroupName) {
        return (_jsxs("div", __assign({ className: "auto-group" }, { children: [_jsxs(Alert, __assign({ purpose: "success" }, { children: [_jsx("h4", { children: "That group already exists!" }), _jsxs("p", { children: ["You're done! ", _jsx("b", { children: existingGroupName }), " has already been copied over to this event and can be joined by your attendees once registration opens!"] })] })), _jsx(Form, __assign({ initialValues: {}, onSubmit: onContinue, useUnsavedPrompt: false, formikBagProps: {
                        hideFooter: true,
                    } }, { children: function (_a) {
                        var formikContext = _a.formikContext;
                        return (_jsx(WidgetFieldset, { children: _jsx(FormikContextListener, { currentPath: path, path: "".concat(Constants.Routes.autogroup), formikContext: formikContext, active: true }) }));
                    } }))] })));
    }
    if (groupCreatedName) {
        return (_jsxs("div", __assign({ className: "auto-group" }, { children: [_jsxs(Alert, __assign({ purpose: "success" }, { children: [_jsx("h4", { children: "Group successfully copied!" }), _jsxs("p", { children: ["You're done! ", _jsx("b", { children: groupCreatedName }), " has been copied over to this event and can be joined by your attendees once registration opens!"] })] })), _jsx(Form, __assign({ initialValues: {}, onSubmit: onContinue, useUnsavedPrompt: false, formikBagProps: {
                        submitButtonLabel: paramsContinueToRegister ? "Continue" : "Close Window",
                        hideFooter: paramsContinueToRegister ? undefined : true,
                    } }, { children: function (_a) {
                        var formikContext = _a.formikContext;
                        return (_jsx(WidgetFieldset, { children: _jsx(FormikContextListener, { currentPath: path, path: "".concat(Constants.Routes.autogroup), formikContext: formikContext, active: true }) }));
                    } }))] })));
    }
    return (_jsxs(_Fragment, { children: [_jsx(InlineError, { id: "autoGroupErrors" }), _jsx("h3", __assign({ className: "m-bottom" }, { children: "Thank you for creating your group in advance!" })), _jsxs("p", { children: ["We'll use your information from last time along with the selection you make below to create the group", " ", _jsx("b", { children: oldGroupName }), " in this new event. To complete the process, please select your group's most common ticket type."] }), path === Constants.Routes.autogroup && (_jsx(AttendeeTypes, { eventData: eventData, path: path, activePaths: [Constants.Routes.autogroup], setGroupsMode: function () { return null; }, attendeeTypeData: attendeeTypeData, preSelectedAttendeeTypeId: preSelectedAttendeeTypeId, isSingleAttendeePicker: true, handleSubmit: onSubmit, showGroupTypes: true, typeCode: typeCode, setSourceAttendee: function () { return null; } }))] }));
};
export default AutoGroup;
